module.exports = __webpack_public_path__ + "img/H00027.ceb12bb6.png";